import React, { useState, useEffect } from 'react'
import AddressAutocomplete from '@/components/EMT/AddressAutocomplete'
import { Address } from '@/dataV3/Common/Address'
import { useTranslation } from 'next-i18next'

interface AddressLocationFormProps {
  initialAddress?: Address
  onChange?: (address: Address, valid: boolean) => void
}

const defaultAddress: Address = {
  '@id': '',
  '@type': 'Address',
  formatted: '',
  zipCode: '',
  city: '',
  country: '',
  latitude: 0,
  longitude: 0,
}

const AddressLocationForm: React.FC<AddressLocationFormProps> = ({ initialAddress, onChange }) => {
  const { t } = useTranslation('connection')
  const [address, setAddress] = useState<Address>(initialAddress || defaultAddress || null)
  const [error, setError] = useState<string>('')

  useEffect(() => {
    setAddress(initialAddress || defaultAddress)
    setError('')
  }, [initialAddress])

  const validate = (value: Address): string => {
    if (!value?.formatted) {
      return t('create-your-profile-petsitter.complete-profile.errors.address')
    }
    return ''
  }

  const handleAddressChange = (addr: Address) => {
    setAddress(addr)
    const err = validate(addr)
    setError(err)
    onChange?.(addr, !err)
  }

  return (
    <>
      <AddressAutocomplete
        label={t('create-your-profile.address-photo.labels.address2')}
        address={address}
        onAddressChange={handleAddressChange}
        addressError={error}
        strict={false}
      />
    </>
  )
}

export default AddressLocationForm
